module.exports = __webpack_public_path__ + "static/media/yellowStar.1ef42704.svg";